import UTIL from '_common/utils/util';

const formUtil = {
  /**
   * 替换某个项的信息
   * @param template
   * @param key
   * @param value
   */
  replaceInfo: (template, key, value) => {
    if (template && Object.hasOwnProperty.call(template, key) && value) {
      const item = UTIL.deepCopy(template[key]);
      Object.entries(value).forEach((formLine) => {
        const formkey = formLine[0];
        const content = formLine[1];
        if (Object.hasOwnProperty.call(item, formkey)) {
          item[formkey] = content;
        }
      });
      return item;
    }
    return {};
  },

  /**
   * 给多输入模板的input key 加上index标识
   * @param template
   * @param key
   * @param index
   */
  addMultiInpuKeyIndex: (template, key, index) => {
    if (template && Object.hasOwnProperty.call(template, key)) {
      const itemData = UTIL.deepCopy(template[key]);
      // 取出 input 属性
      const { input } = itemData;
      if (input && input.length > 0) {
        const inputTemp = input.map((item) => {
          const itemTemp = UTIL.deepCopy(item);
          itemTemp.key = `${item.key}${index}`;
          return itemTemp;
        });
        itemData.input = inputTemp;
        itemData.extend = index;
      }
      return itemData;
    }
    return {};
  },
};

export default formUtil;
